import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./features/counter/counterSlice";
import restaurantListReducer, {
  restaurantListSlice,
  restaurantDetailsSlice,
  reservationsFromRestaurantSlice,
  reservationAcceptSlice,
  availabeTablesToChangeSlice,
  changeTablesSlice,
  tablesSlice,
  restaurantOpenDaysOfTheWeekSlice,
  estimatedTimeCustomersSpendSlice,
  openClosedExceptionsSlice,
  fetchHoursEachTimeSlice,
  placeOfTableSlice,
  fetchConnectTablesSlice,
  create_confirmationSlice,
  getReservationSumsSlice,
  customerAttendUpdateSlice,
  getTutorialStepsSlice,
  createRestaurantSlice,
  destroyItemSlice,
  restaurantNotificationsSlice,
  restaurantCreatePaymentIntentSlice,
  filtersSlice,
  tableConnectionsReducer,
  updateTableConnectionsReducer,
} from "./reducers/restaurantReducers";
import {
  userUpdateReducerSlice,
  userLoginReducerSlice,
  userRegisterReducerSlice,
  fetchUserSubscriptionSlice,
  storeUserSubscriptionSlice,
  getRestaurantSubscriptionSlice,
  getRestaurantClientsSlice,
  fiscalAdressCrudSlice,
  getSubscriptionPackagesSlice,
  whatsappSubscriptionsSlice,
} from "./reducers/userReducers";
import {
  reservationCustomersMenuSlice,
  closedOpenExceptionsDatePickerSlice,
  reservationBlockedWeekdaysSlice,
  reservationZoneSlice,
  openTimeSlice,
  createReservationSlice,
  cancelReservationSlice,
  editReservationSlice,
  reservationActiveSlice,
  reservationLimitPeopleBabySlice,
  reservationPhoneOrEmailConfirmationSlice,
} from "./reducers/reservationReducers";
import { crudManagerPermissionsSlice } from "./reducers/managersReducers";
import paymentsSlice from "./reducers/paymentReducers";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    restaurantList: restaurantListSlice.reducer,
    restaurantDetails: restaurantDetailsSlice.reducer,
    userLogin: userLoginReducerSlice.reducer,
    userRegister: userRegisterReducerSlice.reducer,
    userUpdate: userUpdateReducerSlice.reducer,
    reservationsFromRestaurant: reservationsFromRestaurantSlice.reducer,
    closedOpenExceptionsDatePicker: closedOpenExceptionsDatePickerSlice.reducer,
    reservationBlockedWeekDays: reservationBlockedWeekdaysSlice.reducer,
    reservationZone: reservationZoneSlice.reducer,
    openTime: openTimeSlice.reducer,
    createReservation: createReservationSlice.reducer,
    cancelReservation: cancelReservationSlice.reducer,
    editReservation: editReservationSlice.reducer,
    reservationCustomersMenu: reservationCustomersMenuSlice.reducer,
    reservationActive: reservationActiveSlice.reducer,
    reservationLimitsPeopleBaby: reservationLimitPeopleBabySlice.reducer,
    reservationAccept: reservationAcceptSlice.reducer,
    availableTablesToChange: availabeTablesToChangeSlice.reducer,
    changedTables: changeTablesSlice.reducer,
    restaurantOpenDaysOfTheWeek: restaurantOpenDaysOfTheWeekSlice.reducer,
    estimatedTimeCustomersSpend: estimatedTimeCustomersSpendSlice.reducer,
    openClosedExceptions: openClosedExceptionsSlice.reducer,
    hoursEachTime: fetchHoursEachTimeSlice.reducer,
    restaurantZones: placeOfTableSlice.reducer,
    restaurantTables: tablesSlice.reducer,
    connectTablesConfig: fetchConnectTablesSlice.reducer,
    createConfirmation: create_confirmationSlice.reducer,
    userSubscription: fetchUserSubscriptionSlice.reducer,
    storeUserSubscription: storeUserSubscriptionSlice.reducer,

    customerAttendUpdate: customerAttendUpdateSlice.reducer,
    restaurant_subscription: getRestaurantSubscriptionSlice.reducer,
    tutorial_steps: getTutorialStepsSlice.reducer,
    create_a_restaurant: createRestaurantSlice.reducer,
    destroy_Item: destroyItemSlice.reducer,
    restaurant_clients: getRestaurantClientsSlice.reducer,
    crudManager: crudManagerPermissionsSlice.reducer,
    restaurantNotifications: restaurantNotificationsSlice.reducer,
    fiscalAddressStore: fiscalAdressCrudSlice.reducer,
    subscriptionPackagesStore: getSubscriptionPackagesSlice.reducer,
    paymentIntent: restaurantCreatePaymentIntentSlice.reducer,
    whatsappSubscriptions: whatsappSubscriptionsSlice.reducer,
    filtersModels: filtersSlice.reducer,
    emailOrPhoneConfirmation: reservationPhoneOrEmailConfirmationSlice.reducer,
    payments: paymentsSlice.reducer,
    tableConnections: tableConnectionsReducer,
    updateTableConnections: updateTableConnectionsReducer,
    reservationSums: getReservationSumsSlice.reducer,
  },
});
